__turbopack_context__.v({
  "bentoCard": "ProductCardSection-module__vB_Caa__bentoCard",
  "corporateHead": "ProductCardSection-module__vB_Caa__corporateHead",
  "light": "ProductCardSection-module__vB_Caa__light",
  "m1": "ProductCardSection-module__vB_Caa__m1",
  "popularTag": "ProductCardSection-module__vB_Caa__popularTag",
  "ring": "ProductCardSection-module__vB_Caa__ring",
  "root": "ProductCardSection-module__vB_Caa__root",
});
